
<div class="h-auto relative flex flex-col justify-center items-center gap-2">
    <mat-icon class="cursor-pointer" (click)="closePopUp()">close</mat-icon>
    <span class="flex" style="align-items: center;justify-content: center; font-size: 20px; font-weight: 500;">{{listTypeLabel}}</span>
    
    <div class="border border-solid border-1 border-gray-300 rounded-2xl py-2 px-2" style="height: 150px; max-width: 400px; min-width: 200px; overflow-y: scroll; scrollbar-color:#386AF6 #386AF6;">
        <div *ngFor="let category of getObjectKeys(exclusions)">
            <span style="font-size: 14px; font-weight: 600;">{{ category.charAt(0).toUpperCase()+category.slice(1)}}</span>
            <div class="flex gap-2 justify-start flex-wrap text-gray-600 font-medium" style="font-size: 12px; width: 328px;">
                <p class="bg-gray-200 p-2 rounded-2xl" *ngFor="let item of exclusions[category]">{{ item }}</p>
            </div>
        </div>
    </div>
    <!-- <a (click)="RaiseRequestComponent()" class="cursor-pointer text-center px-4 py-2 text-blue-500 rounded-full" style="border: 1px solid #386AF6;">Raise request to exclude more</a> -->
</div>